import { DISCLAIMER_LOCATION_TYPES, FORM_STYLE } from 'utils/constants';

export const Forms = {
  1: createBasicSavedForm(1, 'Form Update tests'),
  2: createBasicSavedForm(2, 'Picklist and Form Branching Tests'),
  3: createBasicSavedForm(3, 'Radio Button tests'),
  4: createBasicSavedForm(4, 'State and Country tests'),
  5: createBasicSavedForm(5, 'Degree Offering tests'),
  6: createBasicSavedForm(6, 'Inferred Fields tests'),
};

function createBasicSavedForm(id, name) {
  return {
    id,
    name,
    title: null,
    introText: null,
    introSubText: null,
    thankYouURL: null,
    leadSource: null,
    splashCreative: null,
    formStyle: FORM_STYLE.STANDARD,
    gdprSetting: 'geo',
    extras: {
      branchingFields: {},
      thankYouRoutingFields: {},
      syntheticContentEntities: {
        disclaimers: {
          [DISCLAIMER_LOCATION_TYPES.body]: {
            show: false,
            value: '',
          },
          [DISCLAIMER_LOCATION_TYPES.footer]: {
            show: false,
            value: '',
          },
        },
        inferredFields: {},
      },
    },
    program: {
      degreeOffering: 'unc-mba',
      id: 1,
      salesforceOrg: 'unc-mba',
      offering: 'unc-mba',
      fullName: 'Master of Business Administration',
    },
    screens: [
      {
        id: 1,
        edges: [],
        isSubmittable: true,
        isStartScreen: true,
        fields: [
          {
            hidden: false,
            label: '[--link:http://www.google.com]First[link--] [--tip:Tip Test]Name[tip--]',
            name: 'first_name',
            required: true,
            type: 'text',
            value: {
              text: '',
            },
            flags: [
              'nonremovable',
            ],
            uiOrder: 0,
            condition: '',
            helpText: '',
            id: 1,
          },
          {
            hidden: false,
            label: 'Last Name',
            name: 'last_name',
            required: true,
            type: 'text',
            value: {
              text: '',
            },
            flags: [
              'nonremovable',
            ],
            uiOrder: 1,
            condition: '',
            helpText: '',
            id: 2,
          },
          {
            hidden: false,
            label: 'Email',
            name: 'email',
            required: true,
            type: 'text',
            value: {
              text: '',
            },
            flags: [
              'nonremovable',
            ],
            uiOrder: 2,
            condition: '',
            helpText: '',
            id: 3,
          },
          {
            hidden: false,
            label: 'US Marketing Consent 🇺🇸',
            name: 'lead_share_opt_in',
            required: true,
            type: 'nonGDPRConsent',
            value: {
              defaultChecked: true,
              checkboxText: 'Checkbox Text with [--link:https://google.com id:other-id]important link[link--] in it.',
              format: 'checkbox',
              optInValue: 'US Consent Opt In A',
              defaultRadio: 'none',
              disclaimer: 'Disclaimer Text [--link:https://cnn.com id:some-id]With a Link[link--] in it',
            },
            flags: [],
            uiOrder: 3,
            condition: 'render if (("state.no_klondike_gdpr_only_consent" NE "true") AND (("state.no_klondike_carmen_sandiego_region" NE "eu")))',
            helpText: '',
            id: 4,
          },
          {
            hidden: false,
            label: 'GDPR Marketing Consent 🇪🇺',
            name: 'lead_share_opt_in',
            required: true,
            type: 'gdpr_consent',
            value: {
              retailOptIn: {
                text: 'Retail Language [--link:https://cnn.com id:some-id]With a Link[link--] in it',
                email: 'email',
                phone: '',
                sms: '',
              },
              leadShareOptIn: {
                text: 'Lead Share Language [--link:https://cnn.com id:some-id]With a Link[link--] in it',
                leadShareValue: 'GDPR Consent Opt In B',
                email: 'lead share email',
                phone: '',
                sms: '',
              },
              disclaimer: '',
            },
            flags: [],
            uiOrder: 4,
            condition: 'render if (("state.no_klondike_gdpr_only_consent" EQ "true")) OR (("state.no_klondike_carmen_sandiego_region" EQ "eu"))',
            helpText: '',
            id: 5,
          },
        ],
      },
    ],
    grouping: {
      id: 1,
      name: 'unc-mba',
    },
    isExperimentalForm: false,
    formMetadata: {
      isFormJSONEditable: false,
      areAllFieldsOptional: false,
      formAttributesConfig: {},
      experimentalTrialAttributes: {},
    },
    isPublished: false,
    lastPublished: null,
    publishedStatus: 'Unpublished',
  };
}
